export const en = {
  header: {
    title: "Remote Sampling",
  },
  join: {
    joinSession: "Join session",
    connecting: "Connecting to session…",
  },
  controls: {
    microphone: "Microphone",
    camera: "Camera",
    screenShareStart: "Share screen",
    screenShareStop: "Stop screen share",
    leave: "Hang up",
  },
  waitRoom: {
    heading: "We will be right with you",
    text: "You will be able to join the sampling session shortly",
  },
  getStarted: {
    buttonText: "Get started"
  },
  status: { settingUp: "Setting up…" },
  errors: {
    genericError: "Something went wrong",
    genericErrorExtended: "Something went wrong, please try again later",
    tryAgainLater: "Try again later or contact support",
  },
} as const;
